import { render } from "./Configuration.vue?vue&type=template&id=6abbcb40&scoped=true"
import script from "./Configuration.vue?vue&type=script&lang=ts"
export * from "./Configuration.vue?vue&type=script&lang=ts"

import "./Configuration.vue?vue&type=style&index=0&id=6abbcb40&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6abbcb40"

export default script